// WAIIS Summit — single source of truth.
//
// Bug Queue #1 (27 Jun 2026): the dashboard countdown was derived from the
// next plenary MEETING, so it showed "Summit in 3 days · Jun 29 2026". The
// summit is 16–19 November 2026 in Freetown (JMBICC). Drive every
// summit-facing countdown/label from these constants — never from the next
// plenary meeting.
export const SUMMIT_START_DATE = '2026-11-16';
export const SUMMIT_END_DATE = '2026-11-19';
export const SUMMIT_DATES_LABEL = '16–19 Nov 2026';
export const SUMMIT_VENUE = 'Freetown · JMBICC';
